<template>
  <div class="bottom-page">
    <div class="bottom-header">
      <div v-for="(item,index) in menuItems" :key="item.location" :style="index + 1 !== menuItems.length ? 'margin-right: 44px' : '' " style="cursor: pointer" @click="goTo(item)">
        {{ item.label }}
      </div>
    </div>
    <div style="border: 1px dashed #DCDCDC;margin: 16px 0 21px"></div>
    <div class="bottom-footer">
      <div style="font-size: 14px;color: #FFFFFF;margin-right: 56px">
        <div style="margin-bottom: 8px;text-align: center">天津博汇招标有限公司</div>
        <div style="display: flex;justify-content: center;align-items: center;margin-bottom: 8px">
          <div style="margin-right: 40px"> 地址：天津市和平区睦南道109号   </div>
          <div style="margin-right: 40px">联系方式：022-23319722 </div>
          <div>邮箱：zhaobiaobu@bohuizhaobiao.com</div>
        </div>
        <div style="margin-bottom: 8px;text-align: center">版权声明     冀ICP备2024061089号-1冀公网安备13012302000619号</div>


      </div>
      <div>

      </div>
    </div>
  </div>
</template>

<script>



export default {
  computed: {
  },
  components: {  },
  data() {
    return {
      linkList:[
      ],
      menuItems: [
        {label: "网站首页", location: "/home",},
        {label: "交易信息", location: "/about",},
        {label: "下载中心", location: "/download",},
        {label: "关于我们", location: "/ourself",},
      ],
    };
  },
  methods: {
    jump(item){
      window.open(item.url);
    },
    goTo(item) {
      if (item.location === '/guarantee') window.open('https://www.gzzczb.com/guarantee')
      if (item.location === '/bidEvaluationOffice') window.open('https://www.gzzczb.com/bidEvaluationOffice/')
      this.$router.push(item.location);
    }
  }
};
</script>
<style>
.bottom-page{
  height: 182px;
  background: #2C3345;
  font-size: 16px;
  color: #FFFFFF;
}
.bottom-header{
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top:18px ;
}
.bottom-footer{
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;


}
</style>
